import enumBase from './EnumBase';

export default class RecipientState extends enumBase {
  static WAITING = 'waiting';

  static DONE = 'done';

  static REFUSED = 'refused';

  static SIGNING = 'signing';

  static QUEUED = 'queued';

  static SUSPENDED = 'suspended';

  static FAILED = 'failed';

  static FOLLOWING = 'following';

  static values = [
    this.WAITING,
    this.DONE,
    this.REFUSED,
    this.SIGNING,
    this.QUEUED,
    this.SUSPENDED,
    this.FAILED,
    this.FOLLOWING,
  ];

  static canSign(state) {
    return state === this.WAITING;
  }

  static getAllStatesTranslated(i18n) {
    return this.values.map((item) => ({
      value: item,
      label: i18n.te(`signaturesList.recipientStates.${item}`)
        ? i18n.t(`signaturesList.recipientStates.${item}`)
        : item,
    }));
  }
}
